module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo"
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-menu-item', {
      attrs: {
        "index": item.id
      },
      on: {
        "click": function($event) {
          _vm.handlerCategory(item.id)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])])
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "cpy_info"
  }, [_vm._l((_vm.contentData), function(item) {
    return (_vm.contentData.length > 0) ? _c('div', {
      staticClass: "result-item"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.globalUrl.resourceUrl + item.photoUrl
      },
      on: {
        "click": function($event) {
          _vm.clickToRouter(item.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.title,
        "placement": "top-start"
      }
    }, [_c('router-link', {
      staticClass: "show-ellipsis",
      attrs: {
        "to": {
          path: '/cpyResultContent?contentId=' + item.id
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)], 1)]) : _vm._e()
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totalData,
      "layout": "total, prev, pager, next"
    },
    on: {
      "current-change": _vm.initData,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43f28c13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/cpyResultList.vue
// module id = 238
// module chunks = 2